var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import FilterRule from './FilterRule';
/**
 *
 */
var FilterRuleContainsString = /** @class */ (function (_super) {
    __extends(FilterRuleContainsString, _super);
    /**
     *
     * @param param
     */
    function FilterRuleContainsString(param) {
        return _super.call(this, param) || this;
    }
    /**
     *
     * @param object
     * @return {boolean}
     */
    FilterRuleContainsString.prototype.apply = function (object) {
        if (!object) {
            return false;
        }
        if (!this.value || !this.parameter) {
            return true;
        }
        var objectValue = object[this.parameter];
        if (!objectValue) {
            return false;
        }
        if (typeof (objectValue) !== 'string') {
            return false;
        }
        return objectValue.indexOf(this.value) >= 0;
    };
    return FilterRuleContainsString;
}(FilterRule));
export default FilterRuleContainsString;
